/**
 * 全局公共信息变量，用于其他埋点获取当前页面的信息，方便信息获取
 */
const page = {};

/**
 * 设置当前页面信息，一般pv触发后就会调用这个埋点
 * @param {{page_nm:string,sub_page_nm?:string}} data
 */
export function setPage(data) {
  Object.assign(page, data);

  if (!data.sub_page_nm) {
    delete page.sub_page_nm;
  }
}
/**
 * 获取当前页面信息
 * @returns {{
 *  page_nm:string,
 *  sub_page_nm?:string
 * }}
 */
export function getPage() {
  return { ...page };
}

/**
 * 搜索相关信息
 */
const search = {};

export function setSearch(data) {
  Object.assign(search, data);
}

/**
 * 获取搜索相关数据
 * @returns {Record<string, any>}
 */
export function getSearch() {
  return { ...search };
}
